import { render } from "./AuthSelection.vue?vue&type=template&id=78f65ae7&scoped=true"
import script from "./AuthSelection.vue?vue&type=script&lang=js"
export * from "./AuthSelection.vue?vue&type=script&lang=js"

import "./AuthSelection.vue?vue&type=style&index=0&id=78f65ae7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f65ae7"]])

export default __exports__